import { unionWith } from 'lodash-es';

const getFullName = ({ firstName, name }) =>
  firstName ? `${firstName} ${name}` : name;

const getActions = () =>
  [
    {
      route: '/party/',
      action: 'view',
      type: 'link',
      label: 'parties.grid.cell.actions.btn.view.label'
    }
  ];

export const getPartyItem = party => ({
  id: party.id,
  code: party.code,
  // createDate: party.create_date,
  birthDate: party.birthDate,
  fullName: getFullName(party),
  isPerson: party.isPerson,
  person: party.isPerson ? 'natural' : 'legal',
  active: party.active ? 'yes' : 'no',
  actions: getActions()
});

export const getPartyList = parties => {
  try {
    return parties.map(party => getPartyItem(party));
  } catch (e) {
    return [];
  }
};


export const appendPartyList = (partyList, parties2) => {
  try {
    const partyList2 = parties2.map(party => getPartyItem(party));
    return partyList.toJS().concat(partyList2);
  } catch (e) {
    return [];
  }
};

// eslint-disable-next-line no-unused-vars
export const updatePartyList = (partyList, partyItem) => {
  try {
    const item = getPartyItem(partyItem);
    // Find item index using _.findIndex (thanks @AJ Richardson for comment)
    return unionWith([item], partyList, (l, r) => l.id === r.id);
  } catch (e) {
    return partyList;
  }
};
